export function formatExpectedOrderSignal(expectedOrders: number): string {
  const safeExpectedOrders = Number.isFinite(expectedOrders)
    ? Math.max(0, expectedOrders)
    : 0;

  if (safeExpectedOrders === 0) {
    return "当前条件下预计 0 单";
  }

  if (safeExpectedOrders < 1) {
    const contentsPerOrder = new Intl.NumberFormat("zh-CN").format(
      Math.max(1, Math.round(1 / safeExpectedOrders)),
    );
    return `长期平均每 ${contentsPerOrder} 条相似内容约 1 单`;
  }

  const lower = Math.floor(safeExpectedOrders);
  const upper = Math.ceil(safeExpectedOrders);
  const formatter = new Intl.NumberFormat("zh-CN");
  if (lower === upper) return `长期平均约 ${formatter.format(lower)} 单 / 条`;
  return `长期平均约 ${formatter.format(lower)}–${formatter.format(upper)} 单 / 条`;
}
